import React from 'react';

import NewsEventsList from './NewsEventList';


const MainNewsEvent = () => {
  return (
    <>
        <div>
            <NewsEventsList/>
        </div>
    </>
  );
};

export default MainNewsEvent;
